import { cn } from '~/utils/cn';

import type { PropsBox, PropsTouchBox, ShadowLevel } from './interfaces';

const SHADOW_CLASS: Record<ShadowLevel, string> = {
  level1: 'shadow-level1',
  level2: 'shadow-level2',
  level3: 'shadow-level3',
};

export function Box({ children, className, style, shadow, id }: PropsBox) {
  return (
    <div
      id={id}
      className={cn(shadow && SHADOW_CLASS[shadow], className)}
      style={style}
    >
      {children}
    </div>
  );
}

export function TouchBox({
  children,
  className,
  disabled,
  style,
  shadow,
  onClick,
  type = 'button',
  ariaLabel,
}: PropsTouchBox) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        'text-left transition-opacity',
        !disabled && 'hover:opacity-90 active:opacity-75 cursor-pointer',
        disabled && 'opacity-60 cursor-not-allowed',
        shadow && SHADOW_CLASS[shadow],
        className,
      )}
      style={style}
    >
      {children}
    </button>
  );
}
